export const footer: object = {
  footer: {
    findUsOn: 'Finde uns auf',
  }
};
